import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Section, SectionTitle, Reveal, TeamLogo } from "../components/UIBits";
import { TOURNAMENT, CATEGORY_YEARS } from "../lib/constants";
import { useT } from "../lib/i18n";
import api from "../lib/api";

export default function TeamsPage() {
    const { t } = useT();
    const [teams, setTeams] = useState([]);
    useEffect(() => { api.get("/teams?light=true").then(r => setTeams(r.data)); }, []);
    return (
        <div data-testid="teams-page">
            <Helmet><title>{`${t("teams.title_pre")} ${t("teams.title_accent")} — ${TOURNAMENT.name}`}</title></Helmet>
            <Section>
                <SectionTitle kicker={t("teams.kicker")} title={t("teams.title_pre")} accent={t("teams.title_accent")} />
                {TOURNAMENT.categories.map((cat) => {
                    const list = teams.filter(team => team.category === cat);
                    if (!list.length) return null;
                    return (
                        <div key={cat} className="mb-14">
                            <div className="flex items-baseline gap-3 mb-6">
                                <h3 className="font-display text-3xl uppercase tracking-widest text-[#7FD93C]">{t("teams.category_label")} {cat}</h3>
                                <span className="text-xs text-[#4FE0D5] font-mono">{t("teams.born_in")} {CATEGORY_YEARS[cat]}</span>
                                <span className="text-xs text-white/40">{list.length} {t("teams.count_suffix")}</span>
                            </div>
                            <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                {list.map((team, i) => (
                                    <Reveal key={team.id} delay={i * 0.05}>
                                        <Link
                                            to={`/equipes/${team.id}`}
                                            data-testid={`team-card-${team.id}`}
                                            className="block glass-card p-6 h-full hover:border-[#7FD93C] transition-all hover:-translate-y-1"
                                            style={{ borderLeft: `3px solid ${team.color || "#7FD93C"}` }}
                                        >
                                            <div className="flex items-center gap-4 mb-4">
                                                <TeamLogo team={team} size={48} />
                                                <div>
                                                    <div className="font-display text-xl uppercase tracking-wide">{team.name}</div>
                                                    <div className="text-xs text-white/50">{team.category}</div>
                                                </div>
                                            </div>
                                            {team.motto && <div className="text-sm text-white/60 italic">« {team.motto} »</div>}
                                            <div className="mt-4 text-[#4FE0D5] text-xs tracking-[0.3em] uppercase font-bold">{t("teams.see_roster")}</div>
                                        </Link>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                    );
                })}
                {teams.length === 0 && <div className="text-white/50 text-center py-12">{t("common.no_data")}</div>}
            </Section>
        </div>
    );
}
